import React from "react";
import Countdown from "react-countdown";
import { Link } from "react-router-dom";
import i18n from "../../../i18n";
import { BiddingModal } from "../../helpers/biddingModal";
import { toggleLike, toggleWishlist } from "../../../models/auctions";
import { AuctionShare } from "./auctionShare";
import swal from "sweetalert";
import { getLoggedUser } from "../../../state/user";
import { formatCurrency } from "../../../state/utils";
import { VisitNow } from "./visitNow";
import { SaudiRiyalLogo } from "../../logo/saudiLogo";
import CarouselAuctionDetails from "../../carousel/CarouselAuctionDetails";

let is_logged = localStorage.getItem("is_logged_in") ? true : false;
const user = getLoggedUser();

const FinishBid = () => (
  <div className="bid-started">
    <i className="fa fa-clock-o me-2"></i>
    {i18n.t("auction_started")}
  </div>
);

const rendererEnds = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <FinishBid />;
  } else {
    return (
      <div className="countdown-container ends-timer">
        <div className="countdown-header">
          <i className="fa fa-hourglass-half me-2"></i>
          {i18n.t("ends_after")}
        </div>
        <div className="countdown-grid">
          <div className="countdown-item">
            <span className="countdown-number">{days}</span>
            <span className="countdown-label">{i18n.t("lbl_day")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{hours}</span>
            <span className="countdown-label">{i18n.t("lbl_hour")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{minutes}</span>
            <span className="countdown-label">{i18n.t("lbl_minute")}</span>
          </div>
          <div className="countdown-item">
            <span className="countdown-number">{seconds}</span>
            <span className="countdown-label">{i18n.t("lbl_second")}</span>
          </div>
        </div>
      </div>
    );
  }
};

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return "";
  } else {
    return (
      <div className="countdown-container starts-timer">
        <div className="countdown-header">
          <i className="fa fa-play-circle me-2"></i>
          {i18n.t("starts_after")}
        </div>
        <div className="countdown-grid">
          <div className="countdown-item">
            <p className="countdown-number">{days}</p>
            <p className="countdown-label">{i18n.t("lbl_day")}</p>
          </div>
          <div className="countdown-item">
            <p className="countdown-number">{hours}</p>
            <p className="countdown-label">{i18n.t("lbl_hour")}</p>
          </div>
          <div className="countdown-item">
            <p className="countdown-number">{minutes}</p>
            <p className="countdown-label">{i18n.t("lbl_minute")}</p>
          </div>
          <div className="countdown-item">
            <p className="countdown-number">{seconds}</p>
            <p className="countdown-label">{i18n.t("lbl_second")}</p>
          </div>
        </div>
      </div>
    );
  }
};

export class AuctionRowGrouped extends React.Component {
  constructor() {
    super();
    this.state = {
      open_popup: false,
      wishlist: false,
      like: false,
      is_active_light_box: false,
      bidTimeStopped: false,
      now: () => {
        let time = new Date().toLocaleTimeString("en-US", {
          timeZone: "Asia/Riyadh",
        });
        let dt = new Date().toISOString("en-US").split("T")[0];
        let newDt = dt + " " + time;
        newDt = new Date(newDt.replace(/-/g, "/"));
        return newDt;
      },
    };
    this.closeModal = this.closeModal.bind(this);
    this.addWishList = this.addWishList.bind(this);
    this.addLike = this.addLike.bind(this);
    this.incrementTime = this.incrementTime.bind(this);
  }

  componentDidMount() {
    this.setState({ like: this.props.auction.auction_liked });
    this.setState({ wishlist: this.props.auction.auction_wishlisted });
    if (this.props.auction) {
      setInterval(this.incrementTime, 1000);
    }
  }

  incrementTime() {
    let { auction } = this.props;
    if (!auction) {
      console.error("auction is undefined in props");
      return;
    }
    let dt = new Date(auction.server_time);
    dt.setSeconds(dt.getSeconds() + 1);
    auction.server_time = dt;
    this.setState({ auction });
  }

  closeModal() {
    this.setState({ open_popup: false });
  }

  async addWishList(wishlist) {
    if (is_logged) {
      const response = await toggleWishlist({
        auction_id: this.props.auctionId,
        wishlist,
      });
      if (response) {
        this.setState({ wishlist: wishlist });
      }
    }
  }

  async addLike(like) {
    if (is_logged) {
      const response = await toggleLike({
        auction_id: this.props.auctionId,
        like,
      });
      if (response) {
        this.setState({ like: like });
      }
    }
  }

  createDate(dt) {
    return dt ? new Date(dt.replace(/-/g, "/")) : null;
  }

  getStatusBadgeClass(status) {
    const statusClasses = {
      E: "status-expired",
      F: "status-featured",
      A: "status-active",
      U: "status-upcoming",
    };
    return `status-badge ${statusClasses[status] || "status-active"}`;
  }

  render() {
    let current_lng = localStorage.getItem("I18N_LANGUAGE");
    let auction = this.props.auction;
    let images = this.props.images;
    let img_src = process.env.PUBLIC_URL + "/assets/images/placeholder.jpg";
    let auction_images = this.props.images;
    if (images.length > 0) {
      img_src = images[0].image;
    }

    let key = this.props.key;

    let amount_label = "";
    if (this.props.type === "upcoming") {
      amount_label = i18n.t("start_bid_amount");
    } else if (this.props.type === "previous") {
      amount_label = i18n.t("last_bid_amount");
    } else {
      amount_label = i18n.t("current_amount");
    }

    let startDateAr = auction.start_date_ar;
    let endDateAr = auction.end_date_ar;

    let statusAr = auction.status_label;
    let disp_status = "";
    let statusClass = this.getStatusBadgeClass(statusAr?.status);

    if (statusAr && statusAr["status"]) {
      disp_status = current_lng === "ar" ? statusAr["ar"] : statusAr["en"];
    }

    let endTime = new Date(this.createDate(auction.start_date)).getTime();
    let aucEndTime = new Date(this.createDate(auction.end_date)).getTime();

    let end_time = endDateAr && endDateAr["time"] ? endDateAr["time"] : "";
    end_time = end_time.replace("PM", i18n.t("PM"));
    end_time = end_time.replace("AM", i18n.t("AM"));

    let start_time = startDateAr && startDateAr["time"] ? startDateAr["time"] : "";
    start_time = start_time.replace("PM", i18n.t("PM"));
    start_time = start_time.replace("AM", i18n.t("AM"));

    let guarantee_amount = Number(auction.guarantee_amount);
    let orgImage = "";
    if (
      auction &&
      auction.organizationDetails &&
      auction.organizationDetails.file_organization_image_full
    ) {
      orgImage = auction.organizationDetails.file_organization_image_full;
    }

    const currentDate = new Date();
    const auctionStartDate = new Date(auction.start_date);
    let can_show_end_clock = true;

    if (auctionStartDate > currentDate) {
      can_show_end_clock = false;
    }

    return (
      <React.Fragment key={this.props.key}>
        <div className="col-12 mb-3">
          <div className="modern-auction-list">
            {/* Image Section */}
            <div className="auction-image-wrapper">
              {/* <img
                src={img_src}
                className="auction-main-image"
                // alt={current_lng === "ar" ? this.props.title_ar : this.props.title}
                onClick={() => {
                  this.props.getImagePopup(true, images);
                }}
              /> */}
              <CarouselAuctionDetails images={auction_images} />

              <span className={`${statusClass} modern-status-badge`}>
                {disp_status}
              </span>
              {orgImage && (
                <img src={orgImage} alt="Organization" className="org-logo-badge" />
              )}
            </div>

            {/* Content Section */}
            <div className="auction-content-wrapper">
              {/* Desktop Layout */}
              <div className="desktop-layout">
                <div className="row">
                  <div className="col-8">
                    <div className="auction-header-section">
                      <div className="title-section">
                        <h3 className="auction-main-title">
                          {current_lng === "ar" ? this.props.title_ar : this.props.title}
                        </h3>
                        <div className="lot-number">Lot: #MZADSA{auction.id}</div>
                      </div>

                      <div className="info-row">
                        <div className="info-item">
                          <i className="fa fa-calendar"></i>
                          <span>{endDateAr && endDateAr["date"] ? endDateAr["date"] : ""} {end_time}</span>
                        </div>
                        <div className="info-item">
                          <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href={`https://www.google.com/maps?q=${auction.latitude},${auction.longitude}`}
                            className="location-link"
                          >
                            <i className="fa fa-map-marker" style={{ color: 'red', fontSize: "12px" }}></i>
                            <span>{auction.location}</span>
                          </a>
                        </div>
                        {(
                          <div className="rank-badge">
                            <span className="rank-label">My Rank:</span>
                            <span className="rank-number">{auction.my_rank || 0}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="auction-stats-section">
                      <div className="stats-grid">
                        <div className="list-amout-card">
                          <div className="amout-label">{i18n.t("bid_counr")}</div>
                          <div className="amout-value">#{auction.bid_count}</div>
                        </div>

                        <div className="list-amout-card">
                          <div className="amout-label">{i18n.t("start_amount")}</div>
                          <div className="amout-value">
                            {formatCurrency(auction.start_amount)} <SaudiRiyalLogo />
                          </div>
                        </div>

                        <div className="list-amout-card">
                          <div className="amout-label">{amount_label}</div>
                          <div className="amout-value">
                            {formatCurrency(auction.current_amount)} <SaudiRiyalLogo />
                          </div>
                        </div>

                        <div className="list-amout-card">
                          <div className="amout-label">{i18n.t("gurantee_amount")}</div>
                          <div className="amout-value">
                            {formatCurrency(guarantee_amount)} <SaudiRiyalLogo />
                          </div>
                        </div>
                      </div>

                      {Number(auction.visit_amount) > 0 && (
                        <div className="visit-section">
                          <div className="visit-info">
                            <strong>
                              {i18n.t("visit_amount")}: {formatCurrency(auction.visit_amount)} <SaudiRiyalLogo />
                            </strong>
                          </div>
                          {auction.is_visit_active && (
                            <VisitNow
                              amount={auction.visit_amount}
                              type="sitevisit"
                              id={auction.id}
                              gid={auction.group}
                              is_group={false}
                              group={auction.group}
                              main_class="btn-visit-now"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="auction-actions-section">
                  <Link
                    to={"/auction-details/" + this.props.auctionId}
                    className="action-btn-list btn-primary-custom"
                  >
                    <i className="fa fa-info-circle"></i>
                    {i18n.t("view_details")}
                  </Link>

                  {this.props.can_bid && auction.is_enrolled && (
                    <button
                      className="action-btn-list btn-bid"
                      onClick={() => {
                        if (
                          is_logged &&
                          !user.is_staff &&
                          auction.is_staff_auction
                        ) {
                          swal(
                            i18n.t("un_authorized"),
                            i18n.t("non_staff_popup"),
                            "warning"
                          );
                          return;
                        }
                        this.setState({ open_popup: true });
                      }}
                    >
                      <i className="fa fa-gavel"></i>
                      {i18n.t("bid_now")}
                    </button>
                  )}

                  {auction.status === "A" && !auction.is_enrolled && (
                    <Link
                      to={!is_logged ? "/login" : "/enroll/" + auction.id}
                      className="action-btn-list btn-primary-custom"
                    >
                      <i className="fa fa-user-plus"></i>
                      {i18n.t("enroll")}
                    </Link>
                  )}
                </div>
              </div>

              {/* Mobile Layout */}
              <div className="mobile-layout">
                <div style={{display:"flex"}}>
                  <div className="col-8">
                    <div className="mobile-header">
                      <h3 className="mobile-title">
                        {current_lng === "ar" ? this.props.title_ar : this.props.title}
                      </h3>
                      <div className="mobile-lot">Lot: #MZADSA{auction.id}</div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="mobile-actions-list">
                      <Link
                        to={"/auction-details/" + this.props.auctionId}
                        className="mobile-btn btn-primary-custom"
                      >
                        {i18n.t("details")}
                      </Link>

                      {this.props.can_bid && auction.is_enrolled && (
                        <button
                          className="mobile-btn btn-bid-mobile"
                          onClick={() => {
                            if (
                              is_logged &&
                              !user.is_staff &&
                              auction.is_staff_auction
                            ) {
                              swal(
                                i18n.t("un_authorized"),
                                i18n.t("non_staff_popup"),
                                "warning"
                              );
                              return;
                            }
                            this.setState({ open_popup: true });
                          }}
                        >
                          <i className="fa fa-gavel"></i>
                          Bid
                        </button>
                      )}

                      {auction.status === "A" && !auction.is_enrolled && (
                        <Link
                          to={!is_logged ? "/login" : "/enroll/" + auction.id}
                          className="mobile-btn btn-primary-custom"
                        >
                          {i18n.t('enroll')}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>

                <div className="mobile-info-grid" >
                  <div className="mobile-info-item">
                    <i className="fa fa-calendar"></i>
                    <span>{endDateAr && endDateAr["date"] ? endDateAr["date"] : ""}</span>
                    <i className="fa fa-map-marker" style={{ color: 'red', fontSize: "0.4rem" }}></i>
                    <span>{auction.location}</span>
                  </div>
                </div>

                <div className="mobile-stats-row">
                  <div className="mobile-stat">
                    <div className="mobile-stat-label">Bids</div>
                    <div className="mobile-stat-value">#{auction.bid_count}</div>
                  </div>
                  <div className="mobile-stat">
                    <div className="mobile-stat-label">Start</div>
                    <div className="mobile-stat-value">{formatCurrency(auction.start_amount)}</div>
                  </div>
                  <div className="mobile-stat highlight">
                    <div className="mobile-stat-label">Current</div>
                    <div className="mobile-stat-value">{formatCurrency(auction.current_amount)}</div>
                  </div>
                </div>



              </div>
            </div>
          </div>
        </div>

        <BiddingModal
          open_popup={this.state.open_popup}
          closeModal={this.closeModal}
          auction={auction}
          lng={current_lng}
          key={key}
        />
      </React.Fragment>
    );
  }
}